export default function dateToString(date: Date | null) {
    if (!date) {
        return null;
    }

    const formatNumber = (num: number) => num < 10 ? `0${num}` : num.toString();

    return `${formatNumber(date.getDate())}/${formatNumber(date.getMonth() + 1)}/${date.getFullYear()}`;
}